(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3dids-product-list"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-3dids-step] .slideshow-control');
      if (!button) return;

      const slideshow = button.closest('slideshow-component');
      if (!slideshow || !slideshow.slides || !slideshow.classList.contains('resource-list__carousel')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const direction = button.classList.contains('slideshow-control--next') ? 1 : -1;
      const visible = Math.max(slideshow.visibleSlides.length, 1);
      const last = Math.max(slideshow.slides.length - visible, 0);
      let target = slideshow.current + direction;
      if (button.closest('[data-3dids-loop]')) {
        if (target < 0) target = last;
        else if (target > last) target = 0;
      } else {
        target = Math.min(Math.max(target, 0), last);
      }

      if (target !== slideshow.current) slideshow.select(target, event);
    },
    true
  );

  (() => {
    const setup = (root) => {
      const slideshow = root.querySelector('slideshow-component.resource-list__carousel');
      const container = root.querySelector('[data-3dids-dots]');
      if (!slideshow || !container || container.dataset.ready) return;
      container.dataset.ready = 'true';

      if (root.hasAttribute('data-3dids-loop')) {
        slideshow.querySelectorAll('.slideshow-control').forEach((control) => {
          const hideWhenFit = root.hasAttribute('data-hide-fit-arrows-3dids');
          const canScroll = () => !hideWhenFit || slideshow.slides.length > Math.max(slideshow.visibleSlides.length, 1);
          const enable = () => {
            if (control.disabled && canScroll()) control.disabled = false;
          };
          enable();
          new MutationObserver(enable).observe(control, { attributes: true, attributeFilter: ['disabled'] });
        });
      }

      const columns = () => {
        const style = getComputedStyle(root);
        const mobile = parseInt(style.getPropertyValue('--pl-cols-mobile'), 10) || 1;
        const tablet = parseInt(style.getPropertyValue('--pl-cols-tablet'), 10) || mobile;
        const width = window.innerWidth;
        if (width < 750) return mobile;
        if (width < 992) return root.hasAttribute('data-3dids-compact') ? mobile : tablet;
        return mobile;
      };
      const build = () => {
        const total = slideshow.slides ? slideshow.slides.length : 0;
        const pages = Math.ceil(total / columns());
        root.toggleAttribute('data-fit-3dids', total <= columns());
        container.innerHTML = '';
        for (let page = 0; page < pages; page++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-list-dots-3dids__dot';
          dot.setAttribute('aria-label', String(page + 1));
          dot.addEventListener('click', () => slideshow.select(Math.min(page * columns(), total - 1)));
          container.appendChild(dot);
        }
        update();
      };
      const update = () => {
        const page = Math.floor((slideshow.current || 0) / columns());
        [...container.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === page)));
      };

      build();
      const scroller = slideshow.querySelector('slideshow-slides');
      let timer;
      if (scroller) {
        scroller.addEventListener('scroll', () => {
          clearTimeout(timer);
          timer = setTimeout(update, 80);
        });
      }
      slideshow.addEventListener('slideshowselect', update);
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 150);
      });
    };

    const init = () => document.querySelectorAll('[data-3dids-step]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
    document.querySelectorAll('product-recommendations').forEach((element) => {
      let timer;
      new MutationObserver(() => {
        clearTimeout(timer);
        timer = setTimeout(init, 150);
      }).observe(element, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
